<template>
  <section class="content-manage">
    <HeaderTitle :title="'Configurações'" :image="'config'"/>
    <div class="content-manage-itens">
      <b-tabs>
        <b-tab title="Versão Premium" active>
          <div class="content-manage-premium">
            <div class="row">
              <div class="col-12 col-lg-8">
                <div class="content-input-default-two mb-0">
                  <input type="text" name="resources" v-model="resources" placeholder="Recursos" required/>
                </div>
              </div>
              <div class="col-12 col-lg-4 d-flex align-items-end">
                <button class="btn-green--small" @click="toggleResources(resources)">
                  Adicionar
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-8">
                <div class="content-resources-saved" v-for="resource in premiumResources" :key="resource.id">
                  <p>{{ resource.text }}</p>
                  <button class="content-resources-saved-icon" @click="toggleResources(resource)">
                    <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 384 512">
                      <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <template v-if="false">
              <div class="row">
                <div class="col-12">
                  <div class="content-manage-premium--title">
                    <h2>Planos Premium</h2>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-lg-6">
                  <div class="content-input-default-two-select"
                  :class="{'content-input-default-two-select--active': premiumData.name && premiumData.name !== ''}">
                    <select v-model="premiumData.name" required>
                      <option value="" selected disabled>Selecione o plano</option>
                      <option v-for="category in plansCategories" :key="category.id" :value="category.name">{{ category.name }}</option>
                    </select>
                    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_35_1490" maskUnits="userSpaceOnUse" x="0" y="0" width="7" height="12" style="mask-type: luminance;"><path d="M0.920705 12H7L7 0.543873H0.920705L0.920705 12Z" fill="white"></path></mask><g mask="url(#mask0_35_1490)"><path d="M6.77741 6.84966C7.0742 6.53013 7.0742 6.01118 6.77741 5.69165L2.21883 0.78349C1.92207 0.463963 1.44008 0.463963 1.14331 0.78349C0.846487 1.10307 0.846487 1.62196 1.14331 1.94155L5.16529 6.27191L1.14569 10.6023C0.848868 10.9219 0.848868 11.4408 1.14569 11.7603C1.44246 12.0799 1.92445 12.0799 2.22121 11.7603L6.77979 6.85221L6.77741 6.84966Z" fill="black"></path></g></svg>
                  </div>
                </div>
                <div class="col-12 col-lg-6">
                  <div class="content-input-default-two">
                    <input type="text" name="price" v-model="premiumData.price" @blur="formatPrice" placeholder="Preço do plano" required/>
                  </div>
                </div>
                <div class="col-12">
                  <div class="content-input-default-two">
                    <textarea v-model="premiumData.description" name="description" placeholder="Descrição do plano"></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn-green" @click="handleRegisterPremium()">Salvar</button>
                </div>
              </div>
              <template v-if="premiumPlans.length > 0">
                <div class="row">
                  <div class="col-12">
                    <div class="content-manage-premium--title">
                      <h2>Cadastrados</h2>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="card-plan-premium" v-for="premium in premiumPlans" :key="premium.id">
                    <div class="card-plan-premium--name">
                      <p>{{ premium.name }}</p>
                    </div>
                    <div class="card-plan-premium--price">
                      <p>{{ premium.price | money }}</p>
                    </div>
                    <div class="card-plan-premium--description">
                      <p>{{ premium.description }}</p>
                    </div>
                    <div class="card-plan-premium-btns">
                      <button type="button" class="btn--edit" @click="changePremium('edit', premium)">
                        <img class="img-fluid" src="@/assets/img/btn-edit.png" alt="icon edit" title="icon edit"/>
                      </button>
                      <button type="button" class="btn--remove" @click="changePremium('delete', premium)">
                        <img class="img-fluid" src="@/assets/img/btn-excluir.png" alt="icon delete" title="icon delete"/>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import HeaderTitle from '@/components/headers/HeaderTitle';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      resources: '',
      premiumData: {
        name: '',
        price: '',
        description: '',
      },
      plansCategories: [
        {
          id: 1,
          name: 'Plano Anual',
        },
        {
          id: 2,
          name: 'Plano Mensal',
        }
      ]
    }
  },
  components: {
    HeaderTitle
  },
  computed: {
    ...mapGetters('User', ['user']),
    ...mapGetters('Manage', ['premiumResources', 'premiumPlans'])
  },
  methods: {
    ...mapActions('Manage', ['consultPlansPremium', 'registerPremiumResources',
    'registerPremium', 'removePremiumResources', 'removePremium']),
    async toggleResources(value) {
			const index = this.premiumResources.indexOf(value);

			if (index > -1) {
        await this.removePremiumResources(value.id);
			} else {
        let obj = {
          id_user: this.user.id,
          resources: this.resources
        };
        await this.registerPremiumResources(obj);
			}

			this.resources = '';
    },
    async handleRegisterPremium() {
      let obj = {
        id_user: this.user.id,
        ...this.premiumData
      };
      await this.registerPremium(obj);
      this.clearAllInputsPremium();
    },
    formatPrice() {
      if (this.premiumData.price !== '') {
        // Formatar como moeda
        this.premiumData.price = new Intl.NumberFormat('en-US').format(this.premiumData.price);
      }
    },
    clearAllInputsPremium() {
      this.premiumData = {
        name: '',
        price: '',
        description: '',
      }
    },
    changePremium(type, value) {
      if (type === 'edit') {
        this.premiumData = value;
      }
      if (type === 'delete') {
        this.$swal.fire({
          html: `Tem certeza que deseja deletar o
          <b style=" display: block; font-size: 24px; color: #EF0000;">${value.name}?<b>`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#EF0000',
          confirmButtonText: 'SIM',
          cancelButtonText: 'NÃO'
        }).then(async (result) => {
          if (result.isConfirmed) {
            await this.removePremium(value.id);
            this.$swal.fire({
              icon: 'success',
              html: `${value.name} removido com sucesso!`,
            })
          }
        })
      }
    },
  },
  mounted() {
    this.consultPlansPremium();
  }
}
</script>

<style lang="scss">
.content-manage {
  &-premium {
    padding: 50px 0px;
    &--title {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 30px 0px;
      margin-bottom: 30px;
      &::before {
        content: '';
        display: block;
        width: calc(50% - 125px);
        height: 1px;
        background: #7ae53a;
      }
      &::after {
        content: '';
        display: block;
        width: calc(50% - 125px);
        height: 1px;
        background: #7ae53a;
      }
      h2 {
        font-size: 24px;
        font-family: 'Font Semibold';
        color: var(--black);
        width: 250px;
        text-align: center;
        margin-bottom: 0;
      }
    }
    .content-resources-saved {
      display: flex;
      align-items: center;
      color: #515c5d;
      background: var(--white);
      border: 1px solid #ccc;
      border-radius: 4px;
      cursor: default;
      float: left;
      margin: 10px 10px 10px 0px;
      padding: 0 6px;
      p {
        font-size: 16px;
        font-family: 'Font Regular';
        color: var(--gray-dark);
        margin-right: 10px;
        margin-bottom: 0;
      }
      &-icon {
        background: 0;
        border: 0;
        padding: 0;
        svg {
          width: 15px;
          height: 15px;
          fill: var(--gray-dark);
        }
      }
    }
    .btn-green--small {
      padding: 0px 20px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;
      background:#28a745;
      border: 0;
      border-radius: 20px;
      font-size: 16px;
      font-family: 'Font Regular';
      color: #fff;
      text-transform: uppercase;
      transition: 500ms;
      &:hover, &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    .card-plan-premium {
      padding: 20px 15px 10px 15px;
      background: var(--white);
      border-radius: 15px;
      box-shadow: 0px 1px 3px rgba(0,0,0,0.25);
      margin-bottom: 30px;
      margin-right: 30px;
      text-align: left;
      &--name {
        p {
          font-size: 18px;
          font-family: 'Font Bold';
          color: var(--black);
          margin-bottom: 5px;
        }
      }
      &--price {
        p {
          font-size: 16px;
          font-family: 'Font Regular';
          color: var(--black);
          margin-bottom: 5px;
        }
      }
      &--description {
        p {
          font-size: 14px;
          font-family: 'Font Light';
          color: var(--black);
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin-bottom: 0;
        }
      }
      &-btns {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 10px;
        .btn--edit, .btn--remove {
          background: 0;
          border: 0;
          padding: 0;
          transition: 500ms;
          &:hover,&:focus {
            cursor: pointer;
            opacity: 0.6;
          }
        }
        .btn--edit {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
